/*

jvCalendar
============


Full Calendar (v3.9.0) Plugin usage

Requires
* jquery-ui-1.10.3
* jquery-1.10.2
* moment.min.js
* fullcalendar.min.js
* fullcalendar.min.css

<div jv-calendar="calendarOptions" jv-calendar-events="events" class="calendar"></div>

        Set this object in the controller
        $scope.calendarOptions = {

        };

https://fullcalendar.io/docs#toc

*/

angular.module('jv.Common.Directives.Calendar', [])

.directive('jvCalendar', function($compile){
    return {
        scope: {
            jvCalendar: '=',
            jvCalendarEvents: '=',
            jvCalendarLegends: '='
        },
        link: function(scope, iElm, iAttrs, ngModel) {
//             default options
            var options = angular.extend({
                defaultView: 'agendaDay',
                slotEventOverlap: false,
                allDaySlot: false,
                header: {
                    left: 'title prev, next',
                    center: '',
                    right: 'agendaDay, agendaWeek, agenda' // buttons for switching between views
                },
                eventRender: function(event, element, view){
                    //to render html view in the title
                    var title = element.find('.fc-title, .fc-list-item-title');
                    title.html(title.text());
                }
            }, scope.jvCalendar || {});

//             in any case we add events, it goes here.
            scope.$watch('jvCalendarEvents', function(events, old){
                if(events){
                    if(angular.isArray(events)){
                        iElm.fullCalendar('renderEvents', events, true);
                    }else{
                        iElm.fullCalendar('renderEvent', event, true);
                    }
                }
            });

//             any option that you want to toggle , goes here
            scope.$watch('jvCalendar', function(newOptions){
                if(angular.isDefined(newOptions.slotEventOverlap)){
                    iElm.fullCalendar('option', 'slotEventOverlap', newOptions.slotEventOverlap);
                }

                if(angular.isDefined(newOptions.allDaySlot)){
                    iElm.fullCalendar('option', 'allDaySlot', newOptions.allDaySlot);
                }
            });

            iElm.fullCalendar(options);
            if(scope.jvCalendarLegends && Object.keys(scope.jvCalendarLegends) !== 0) {
                var el = angular.element('<span/>');
                el.append(  '<div ng-repeat="(jvId,legend) in jvCalendarLegends">' +
                                '<div class="margin-top-small margin-bottom-none padding-right-regular padding-left-xx-small legend {{legend.legendKeyClass}}" ng-if="legend.legendIf">' +
                                    '<div class="inline legend-icon {{legend.legendClass}}"><input type="checkbox" ng-if="legend.legendCheckbox" ng-click="legend.action()" ng-model="legend.modelDefault"></div>' +
                                    '<div class="inline">' +
                                        '{{legend.legendText}}' +
                                    '</div>' +
                                '</div>' +
                            '</div>');
                $compile(el)(scope);
                iElm.append(el);
            }

        }
    };
});
